import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

const dateFormat = 'MM/dd/yyyy';

export const dateMinMaxValidator = (minDate: string | null, maxDate: string | null): ValidatorFn => {
    const minDateTime = minDate ? DateTime.fromFormat(minDate, dateFormat) : null;
    const maxDateTime = maxDate ? DateTime.fromFormat(maxDate, dateFormat) : null;
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value && control.value !== '') {
            const dateTime = DateTime.fromJSDate(control.value);
            if (!dateTime.isValid) {
                return { badDate: { value: control.value } };
            }
            if (minDateTime && dateTime < minDateTime) {
                return { beforeMinDate: { value: control.value, minDate: minDate } };
            }
            if (maxDateTime && dateTime > maxDateTime) {
                return { afterMaxDate: { value: control.value, maxDate: maxDate } };
            }
        }
        return null;
    };
};
